// src/BlogIndex.jsx
import { useEffect } from "react";
import { blogPosts } from "./blogPosts";

const BlogIndex = ({ onBack, onPostSelect }) => {
  useEffect(() => {
    document.title = "Blog | Ask Irene — Medical Billing Guidance";
    return () => {
      document.title =
        "Ask Irene — Free Medical Bill Advisor | Navigate Medical Billing & Find Financial Assistance";
    };
  }, []);

  return (
    <section
      style={{
        padding: "clamp(64px, 10vh, 120px) 24px 80px",
        maxWidth: "720px",
        margin: "0 auto",
      }}
    >
      <button
        onClick={onBack}
        aria-label="Go back"
        style={{
          background: "none", border: "none", cursor: "pointer",
          fontSize: "14px", color: "var(--ink-muted)", fontFamily: "inherit",
          marginBottom: "32px", padding: 0,
        }}
        onMouseEnter={(e) => (e.target.style.color = "var(--ink)")}
        onMouseLeave={(e) => (e.target.style.color = "var(--ink-muted)")}
      >
        &larr; Back
      </button>

      <p style={{
        fontSize: "13px", fontWeight: "500", color: "var(--accent)",
        letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "16px",
      }}>
        Blog
      </p>

      <h1 style={{
        fontFamily: "'DM Serif Display', serif",
        fontSize: "clamp(28px, 4vw, 40px)", fontWeight: "400",
        color: "var(--ink)", letterSpacing: "-0.02em",
        lineHeight: 1.2, marginBottom: "48px", maxWidth: "560px",
      }}>
        Guides and advice for navigating medical bills
      </h1>

      <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
        {blogPosts.map((post, i) => (
          <article
            key={post.slug}
            style={{
              paddingTop: i === 0 ? 0 : "36px",
              paddingBottom: "36px",
              borderBottom: "1px solid var(--border-light)",
            }}
          >
            <p style={{
              fontSize: "13px", color: "var(--ink-muted)",
              marginBottom: "10px", letterSpacing: "0.02em",
            }}>
              {post.date}
            </p>
            <h2 style={{
              fontFamily: "'DM Serif Display', serif",
              fontSize: "clamp(20px, 3vw, 24px)", fontWeight: "400",
              color: "var(--ink)", letterSpacing: "-0.01em",
              lineHeight: 1.3, marginBottom: "12px",
            }}>
              {post.title}
            </h2>
            <p style={{
              fontSize: "15px", lineHeight: 1.75, color: "var(--ink-soft)",
              marginBottom: "16px", maxWidth: "600px",
            }}>
              {post.excerpt}
            </p>
            <button
              onClick={() => onPostSelect(post.slug)}
              style={{
                background: "none", border: "none", cursor: "pointer",
                fontSize: "14px", fontWeight: "500", color: "var(--accent)",
                fontFamily: "inherit", padding: 0,
                textDecoration: "underline", textUnderlineOffset: "3px",
              }}
              onMouseEnter={(e) => (e.target.style.color = "var(--accent-light)")}
              onMouseLeave={(e) => (e.target.style.color = "var(--accent)")}
            >
              Read more &rarr;
            </button>
          </article>
        ))}
      </div>
    </section>
  );
};

export default BlogIndex;
